import type { FaireProductEntity } from "../../entity_types/product";

export const p_nr3ddhuzkf: FaireProductEntity = {
  token: "p_nr3ddhuzkf",
  type: "product",
  name: "Classic Recipes of Norway by Janet Laurence",
  brandToken: "b_7a909d43",
  brandName: "Simon & Schuster",
  imageUrl:
    "https://cdn.faire.com/fastly/358e409621db5ea4ad5efc6d75470243e6661ef56b3c1465b16b872a10adba45.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description:
    "[Anness Publishing]\r\n\r\n• Discover the delights of a distinctive Scandinavian cuisine in this new little book on Norwegian food and cooking\r\n \r\n• Includes traditional dishes such as Norwegian Fish Mousse and Beef Patties with Gravy, as well as regional specialities that include Bird’s Nest Salad, Roe Deer Medallions with Redcurrants, and Tosca Cake\r\n \r\n• The introduction offers a concise overview of this highly regarded culinary tradition, plus a guide to the main ingredients of the country •From classic recipes for meatballs and marinated herrings to unexpected combinations and local variations, this lovely book unearths the mysteries of the magical food and cooking of Norway\r\n \r\n• Nutritional information for every recipe is given\r\n \r\n• Illustrated with wonderful photographs by William Lingwood of practical steps and final dishes\r\n \r\nThe pearly clarity of the northern light of Norway is reflected in its pure and wholesome national cuisine. Choose from cold table dishes such as Herb Cur",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:33.051Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
